import { Box, ButtonBase, Typography } from "@mui/material";

import styles from "./styles";

interface Props {
  icon?: JSX.Element;
  snippet: string | JSX.Element;
  title?: string | JSX.Element;
  description: string | JSX.Element;
  buttonText?: string;
  handleClick?: () => void;
  onClose?: () => void;
}
const StyledBanner = ({
  icon,
  snippet,
  title,
  description,
  buttonText,
  handleClick,
  onClose,
}: Props) => {
  return (
    <Box sx={styles.banner}>
      {icon && <Box sx={styles.icon}>{icon}</Box>}

      <Typography sx={styles.text}>
        <Box component="span" sx={styles.snippet}>
          {snippet}
        </Box>
        {title && (
          <Box component="span" sx={styles.snippet}>
            {" "}
            {title}
          </Box>
        )}
        {description && (
          <Box component="span" sx={styles.description}>
            {" "}
            {description}
          </Box>
        )}
      </Typography>

      {buttonText && handleClick && (
        <ButtonBase sx={styles.button} onClick={handleClick}>
          {buttonText}
        </ButtonBase>
      )}

      {onClose && (
        <ButtonBase sx={styles.dismiss} onClick={onClose} aria-label="Dismiss">
          <Box component="i" className="fa-regular fa-xmark" />
        </ButtonBase>
      )}
    </Box>
  );
};

export default StyledBanner;
